import { ChartReportRow } from './chart-report.models';
export const CHART_REPORTS: Record<string, { endpoint: string; title: string }> = {
  '15': { endpoint: 'Report_VelocityChangeGraph', title: 'نمودار سرعت خودرو' },
  '15-1': { endpoint: 'Tanker_Report_DischargeBasedTime', title: 'نمودار روند تخلیه آب از تانکر' },
  '15-2': { endpoint: 'Tanker_Report_DischargeBasedSpeed', title: 'نمودار روند تخلیه آب از تانکر براساس سرعت' },
  '15-3': { endpoint: 'Report_AccelerationGraph', title: 'نمودار شتاب خودرو' },
  '15-4': { endpoint: 'Fueltank_Consumption_Time', title: 'نمودار مصرف براساس زمان' },
  '15-5': { endpoint: 'Fueltank_InstantConsumption_Report', title: 'نمودار مقدار سوخت مصرفی لحظه‌ای' },
  '15-6': { endpoint: 'Flowmeter_Flowtrend', title: 'روند جریان براساس داده‌های فلومتر' },
};
export function chartLabel(row: ChartReportRow): string {
  return String(row.X ?? row.strTime ?? row.strDateTime ?? row.iSpeed ?? row.strSTime ?? '');
}
export function chartValue(row: ChartReportRow): number | null {
  const raw = row.Y ?? row.fVolume ?? row.Acceleratio ?? row.fValue ?? row.fLiter;
  return raw != null && Number.isFinite(Number(raw)) ? Number(raw) : null;
}
export function chartPosition(row: ChartReportRow, acceleration: boolean): { fLon: number; fLat: number } | null {
  const lon = acceleration ? row.dLongitude : row.fLon;
  const lat = acceleration ? row.dLatitude : row.fLat;
  if (lon == null || lat == null) return null;
  const fLon = Number(lon), fLat = Number(lat);
  return Number.isFinite(fLon) && Number.isFinite(fLat) && Math.abs(fLon) <= 180 && Math.abs(fLat) <= 90 && (fLon !== 0 || fLat !== 0) ? { fLon, fLat } : null;
}
